function UserList() {
    /// <summary>
    /// This object provides common functions for the Widget.Membership.UserList.vb <br/>
    /// Author: ARF<br />
    /// Date: 17.5.2016<br />
    /// Copyright ©: EUDT GmbH 2016 <br />
    /// Version-History:<br />
    /// **********************************************************************<br />
    /// *** v1.0.0 - 8.6.2016                                              *<br />
    /// **********************************************************************<br />
    /// * - basic functionality                                              *<br />
    /// **********************************************************************<br />
    /// </summary>
    this.uid = -1;
}
UserList.prototype = new vcTemplate();

UserList.prototype.init = function () {
    /// <summary>
    /// This function inits all checkbox event handlers, click handler and buttons.
    /// </summary>
  var me = this;
    try {
        if (me.error) { return false; }
        me.showInfo("", "", false);

        //fix the height of the content div
        var iWidgetHeader = parseInt(me.visual.find(".widget-header-frame").height(), 10);
        if (isNaN(iWidgetHeader)) {iWidgetHeader = 0;}
        var iHeader = parseInt(me.visual.find("#divHeader").height(), 10);
       
        me.visual.find("#divList").height(me.height - iWidgetHeader - iHeader - 22);

       //init list entry click handler
        me.edit();
        me.visual.find("#divList a").on("click", function(e) { e.stopPropagation() });

        //inits the back button
          me.visual.find('#divBtnBack').button().unbind('click').click(function () {
              return me.back();
          });
        //show/hide internal users
          me.visual.find('#chbStaff').unbind('click').click(function () {
              return me.reload();
          });

            //inits filter 
          me.visual.find('#chbLockedOut, #chbUnregistered,#chbDeleted').off("click").on("click", function () { me.filter(); });
          me.visual.find('.filter').keyup(function () { me.filter();});
          me.visual.find('.filter').change(function () { me.filter(); });

          me.filter();

          me.replaceTags(me.lstMemberships, "col5");
          me.replaceTags(me.lstLogger, "col6");
          me.replaceTags(me.lstCredentials, "col7");

        return true;
    } catch (ex) { me.writeError('init', ex); return false; }
};



UserList.prototype.replaceTags = function (list, col) {
    /// <summary>
    /// This function takes the hidden tagids and replaces them with proper names from the taglist.
    /// </summary>
    var me = this;
    var html;
    var newHtml = "";
    var i, j;
    var ids;
    try {
        if (me.error) { return false; }



        ids = me.visual.find("#lstEntries li ." + col + " .tagList");
       //iterate all entries for the given column and split them
        ids.each(function () {
            html = $(this).html().trim();
            if (html.length > 0) {
                newHtml = "";
                if (html !== "none") {
                    html = html.split(" ");
                    for (i = 0; i < html.length; i++) {
                        //now, replace them with the name
                        for (j = 0; j < list.length; j++) {
                            if (list[j].id === html[i]) {
                                newHtml += "<div class='tag";
                                if (list[j].admin) {
                                    newHtml += " admin";
                                }
                               
                                newHtml += "'"
                                if (list[j].active == false) {
                                    newHtml += " style='opacity:0.5'";
                                }

                                newHtml += ">" + list[j].name + "</div>";
                                break;
                            }
                        };
                    }

                } else {
                    newHtml += "<div class='tag error'>" + me.resources.noEntry + "</div>";
                }
                $(this).html(newHtml);
            }
        });
        me.visual.find("#lstEntries li ." + col + " .tagList").show();
        return true;
    } catch (ex) { me.writeError('replaceTags', ex); return false; }
};




UserList.prototype.filter = function () {
    /// <summary>
    /// This function handles the entry filtering.
    /// </summary>
    var me = this;
    try {
        if (me.error) { return false; }
      //remove all filter
        me.visual.find('#lstEntries li .vc-list-item').removeClass("foundcol1 foundcol2 foundcol3 foundcol4 foundcol5 foundcol6 foundcol7 alt");
        //alert("here");

        var bLockedOut = me.visual.find("#chbLockedOut").prop('checked');
        var bUnregistered = me.visual.find("#chbUnregistered").prop('checked');
        var bDeleted = me.visual.find("#chbDeleted").prop('checked');
       
        if (bLockedOut === false &&  bUnregistered === false && bDeleted === false) {
            me.visual.find("#lstEntries li .col1.active").parents(".vc-list-item").addClass("foundcol1");
        } else {
            me.visual.find("#lstEntries li .vc-list-item").addClass("foundcol1");

            if (bLockedOut) {
                me.visual.find('#lstEntries li .vc-list-item').filter(function () { return $(this).find('.fa-lock').length === 0 }).removeClass("foundcol1");
            } else {
                me.visual.find('#lstEntries li .vc-list-item').filter(function () { return $(this).find('.fa-lock').length > 0 }).removeClass("foundcol1");
            }
            if (bUnregistered) {
                me.visual.find('#lstEntries li .vc-list-item').filter(function () { return $(this).find('.fa-registered').length === 0 }).removeClass("foundcol1");
            } else {
                me.visual.find('#lstEntries li .vc-list-item').filter(function () { return $(this).find('.fa-registered').length > 0 }).removeClass("foundcol1");
            }
            if (bDeleted) {
                me.visual.find('#lstEntries li .vc-list-item').filter(function () { return $(this).find('.fa-trash').length === 0 }).removeClass("foundcol1");
            } else {
                me.visual.find('#lstEntries li .vc-list-item').filter(function () { return $(this).find('.fa-trash').length > 0 }).removeClass("foundcol1");
            }
        }

       
        //splitt the filter input and add a 'found + col' css-class to the list
        me.splitFilter(me.visual.find("#txtFilterCol2").val().trim(), "col2");
        me.splitFilter(me.visual.find("#txtFilterCol3").val().trim(), "col3");
        me.splitFilter(me.visual.find("#txtFilterCol4").val().trim(), "col4");
        me.splitFilter(me.visual.find("#txtFilterCol5").val().trim(), "col5");
        me.splitFilter(me.visual.find("#txtFilterCol6").val().trim(), "col6");
        me.splitFilter(me.visual.find("#txtFilterCol7").val().trim(), "col7");
    
        //show/hide the entries and set the alternate row style
        me.visual.find("#lstEntries .vc-list-item").not(".foundcol1.foundcol2.foundcol3.foundcol4.foundcol5.foundcol6.foundcol7").hide();
        me.visual.find("#lstEntries .vc-list-item.foundcol1.foundcol2.foundcol3.foundcol4.foundcol5.foundcol6.foundcol7").show().filter(":even").addClass("alt");
        me.visual.find("#divList").show();
        return true;
    } catch (ex) { me.writeError('filter', ex); return false; }
};


UserList.prototype.splitFilter = function (val, col) {
    /// <summary>
    /// This function splits a single filter input and finds all entries which contain the filter expression. 
    /// </summary>
    var me = this;
    var filter;
    var i;
    try {
        if (me.error) { return false; }

        //get filter expressions
        filter = val.trim();
        if (filter.length > 0) {
            filter = filter.split(" ");
            for (i = 0; i < filter.length; i++) {
                if (filter[i].length > 0) {
                    me.visual.find("#lstEntries li ." + col + ":contains('" + filter[i] + "')").parents(".vc-list-item").addClass("found" + col);
                }
            }
        } else {
            me.visual.find("#lstEntries li ." + col).parents(".vc-list-item").addClass("found" + col);

        }

        return true;
    } catch (ex) { me.writeError('splitFilter', ex); return false; }
};


UserList.prototype.reload = function () {
    /// <summary>
    /// This function reloads the entry list. 
    /// </summary>
    var me = this;
    try {
        if (me.error) {
            return false;
        }
       
        var bShowStaff = me.visual.find("#chbStaff").prop('checked');
        me.visual.find('#divList').html(me.vcC.getLoadingIcon());
        window.VisualCoreService.getData(me.vcvid, me.vcgid, getCurrentTimestamp(), 0, 0, JSON.stringify({"showStaff": bShowStaff, LoggerID: me.filterBlid}), '', me.deviceType, me.langid,me.deviceType,
            function(result) {
                if (result == null) {
                    me.showMessage(me.resources.err_loadData,true);
                    return false;
                }
               
                me.visual.find('#divList').html(result);
                //replace the taglists again
                me.replaceTags(me.lstMemberships, "col5");
                me.replaceTags(me.lstLogger, "col6");
                me.replaceTags(me.lstCredentials, "col7");
                me.edit();
                me.filter();

                return true;
            });
        return true;
    } catch (ex) {
        me.writeError('reload', ex);
        return false;
    }
};


UserList.prototype.edit = function () {
    /// <summary>
    /// This function inits the click handler for one single entry and loads the detail view. <br/>
    /// </summary>
    var me = this;
    try {
        if (me.error) { return false; }
        //init list entry click handler
        me.visual.find('li .vc-list-item').off('click').on("click",function() {
            me.uid = parseInt($(this).attr('data-id'),10);
            me.visual.find('#divList,#divHeader, #divStaff').hide();
            me.visual.find('#divEditFrame').show();//.html(id + " " + username);
            me.visual.find('#divUsername').html($(this).attr('data-username'));
            //open the user details visual
            me.vcVisual.addVisualBaseByName('divEdit', 'VISUAL_MEMBERSHIP_USER_DETAILS', 'Details', getCurrentTimestamp(), parseInt(me.visual.find("#divEditDetails").height(), 10), parseInt(me.visual.find("#divEditDetails").width(), 10), JSON.stringify({ "id": me.uid }), '', me.deviceType);
        });
        return true;

    } catch (ex) { me.writeError('edit', ex); return false; }
};


UserList.prototype.back = function () {
    /// <summary>
    /// This function handles the back button - it shows/hides the detail view and reloads the entries <br/>
    /// </summary>
    var me = this;
 
    try {
        if (me.error) { return false; }
        me.reload();
        me.visual.find('#divEditFrame').hide();
        me.visual.find('#divEditDetails').html('');
        me.visual.find('#divList, #divHeader, #divStaff').show();
        me.uid = -1;
        return true;
    } catch (ex) { me.writeError('back', ex); return false; }
};



UserList.prototype.specificInfoHandling = function (bError) {
    /// <summary>
    /// This function  hides/fades out content on error state. 
    /// </summary>
    var me = this;
    try {
        if (bError) {
            me.visual.find('#divHeader,  #divList').hide();
        }
        return true;
    } catch (ex) { me.writeError('specificInfoHandling', ex);
        return false;
    }
};


UserList.prototype.doEvent = function (event) {
    /// <summary>
    /// This function handles the VCMQ events.
    /// </summary>
    var me = this;

    try {
        if (me.error) { return false; }
        switch (event.msg) {
            case 'MS_CLOSE_USER':
                me.back();
                ; break;
                //    default: break;
        }
        return true;
    } catch (ex) { me.writeError('doEvent', ex); return false; }
   

};

